"use client";

import { useState } from "react";

const FAQ_ITEMS: { q: string; a: string }[] = [
  {
    q: "Сколько стоит СЛОТИСЛОТ?",
    a: "Первые 30 дней — бесплатно и без карты. Дальше 320 ₽ в месяц или 280 ₽ в месяц при оплате за год, то есть 3 360 ₽ за год.",
  },
  {
    q: "Как работает предоплата?",
    a: "Мастер размещает в сервисе свою ссылку или QR-код для оплаты — клиент платит напрямую мастеру (карта, СБП). Сервис денежные средства не принимает, платежи не подтверждает и комиссию не взимает. Оплата подписки проходит картой или через СБП с чеком по 54-ФЗ.",
  },
  {
    q: "Клиенту нужно регистрироваться, чтобы записаться?",
    a: "Нет. Клиент открывает вашу ссылку, выбирает услугу и время, получает подтверждение. Без регистрации и приложений.",
  },
  {
    q: "Что будет после 30 дней бесплатного доступа?",
    a: "Ничего не спишется автоматически. Вы сами решаете, подключать ли тариф. Данные и настройки сохраняются.",
  },
  {
    q: "Как работает промокод на 3 месяца?",
    a: "Активируйте код в кабинете — получите 3 месяца платного тарифа без оплаты. Промо-период не продлевается автоматически; дальше действует выбранный тариф.",
  },
  {
    q: "Где хранятся данные и что с 152-ФЗ?",
    a: "Данные хранятся на серверах в России. Мы работаем в контуре 152-ФЗ и 54-ФЗ, выдаём чеки по правилам ККТ. Политика обработки ПДн опубликована.",
  },
  {
    q: "Можно ли подключить Яндекс.Календарь и Telegram?",
    a: "Да. Есть двусторонняя синхронизация с Яндекс.Календарём и напоминания в Telegram и MAX. Список интеграций — на странице «Интеграции».",
  },
  {
    q: "Можно ли вернуть деньги?",
    a: "Да. При отказе от подписки возвращается стоимость неиспользованного периода. Промо и пробный период возврату не подлежат, так как оплата не взималась.",
  },
  {
    q: "Работает ли на телефоне? Есть приложение?",
    a: "СЛОТИСЛОТ — PWA: работает в браузере и ставится на главный экран телефона или компьютера без сторов.",
  },
  {
    q: "Можно ли экспортировать клиентов, если решу уйти?",
    a: "Да. Клиентскую базу, услуги и историю можно выгрузить. Данные — ваши.",
  },
];

export function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="faq" data-accordion>
      {FAQ_ITEMS.map((item, index) => (
        <details
          key={item.q}
          className="faq__item"
          open={openIndex === index}
          onToggle={(event) => {
            if (event.currentTarget.open) setOpenIndex(index);
          }}>
          <summary className="faq__q">{item.q}</summary>
          <div className="faq__a">
            <p>{item.a}</p>
          </div>
        </details>
      ))}
    </div>
  );
}
